import React from 'react';
import Input from './lib';
import './Page.scss';

function App() {
  return (
    <div className='container-center'>
      <Input />
    </div>
  );
}

export default App;
